import React, { useMemo, useState, useEffect } from "react";
import { notify } from "../ui/notify";
import {
  Button,
  Dropdown,
  Space,
  Segmented,
  Checkbox,
  Menu,
  Select,
} from "antd";
import { FilterOutlined } from "@ant-design/icons";

export default function OutlookRibbon({ view, setView, filters, setFilters, autoridadOptions, onCreateEvent, onOpenPrint, onOpenSearch }) {
  const [filterOpen, setFilterOpen] = useState(false);

  // ====== TIPOS (usar IDs reales de agenda_evento) ======
  const eventTypes = useMemo(
    () => [
      { id: 1, label: "Audiencia" },
      { id: 2, label: "Evento" },
      { id: 3, label: "Pagos" },
      { id: 4, label: "Emision Citatorio" },
      { id: 5, label: "Notificacion Citatorio" },
      { id: 6, label: "Desvinculacion Baja" },
      { id: 7, label: "Desvinculacion Solicitada" },
      { id: 8, label: "Pendiente" },
      { id: 9, label: "Reunion" },
    ],
    []
  );

  // ====== DEFAULT: SOLO SAN LUIS SELECCIONADO ======
  useEffect(() => {
    const hasColor = Array.isArray(filters?.colorTags);
    const hasTypes = Array.isArray(filters?.eventTypeIds);

    if (!hasColor && !hasTypes) {
      setFilters((p) => ({
        ...(p || {}),
        colorTags: ["sw-blue"],
        eventTypeIds: eventTypes.map((t) => t.id),
      }));
      return;
    }

    if (!hasColor) {
      setFilters((p) => ({ ...(p || {}), colorTags: ["sw-blue"] }));
    }
    if (!hasTypes) {
      setFilters((p) => ({ ...(p || {}), eventTypeIds: eventTypes.map((t) => t.id) }));
    }
  }, [filters, setFilters, eventTypes]);

  const selectedTypeIds = filters?.eventTypeIds || [];

  const toggleTypeId = (id) => {
    const cur = new Set(selectedTypeIds);
    if (cur.has(id)) cur.delete(id);
    else cur.add(id);
    setFilters((p) => ({ ...(p || {}), eventTypeIds: Array.from(cur) }));
  };

  const filterMenuItems = useMemo(() => {
    const rowStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      width: 320,
      padding: "6px 4px",
      fontSize: 15,
    };

    const mkLeaf = (key, leftNode, checked, onToggle) => ({
      key,
      label: (
        <div
          style={rowStyle}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggle();
          }}
        >
          <div style={{ display: "flex", alignItems: "center", fontWeight: 500 }}>{leftNode}</div>

          <Checkbox
            checked={checked}
            style={{ transform: "scale(1.15)" }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onChange={() => onToggle()}
          />
        </div>
      ),
    });

    return [
      {
        key: "tipos",
        label: <span style={{ fontSize: 15, fontWeight: 600 }}>Tipo de evento</span>,
        children: eventTypes.map((t) =>
          mkLeaf(
            `type_${t.id}`,
            <span style={{ fontSize: 15 }}>{t.label}</span>,
            selectedTypeIds.includes(t.id),
            () => toggleTypeId(t.id)
          )
        ),
      },
    ];
  }, [eventTypes, selectedTypeIds]);

  const whats = () => {
    const phone = "526532095876";
    if (!phone || phone.includes("#")) {
      notify.error({ message: "Configura el número de WhatsApp del licenciado" });
      return;
    }

    const viewLabel =
      view === "day" ? "Día" : view === "week_work" ? "Semana laboral" : view === "week" ? "Semana" : view === "month" ? "Mes" : String(view || "");

    const enabled = Object.entries(filters || {})
      .filter(([, v]) => !!v)
      .map(([k]) => k);

    const lines = [
      "Hola, este es un mensaje del Departamento de Innovación y Tecnología.",
      "Mensaje de prueba.",
      "",
      `Vista: ${viewLabel}`,
      `Filtros activos: ${enabled.length ? enabled.join(", ") : "ninguno"}`,
    ];

    const text = lines.join("\n");
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;

    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w) {
      notify.warning({
        message: "Popup bloqueado",
        description: "Tu navegador bloqueó la ventana. Permite popups o abre el link en la misma pestaña.",
      });
      return;
    }

    notify.success({ message: "WhatsApp abierto. Presiona Enviar." });
  };

  const menuNode = (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{ background: "#fff", borderRadius: 14, boxShadow: "0 10px 28px rgba(0,0,0,.15)", padding: 8 }}
    >
      <Menu
        mode="vertical"
        items={filterMenuItems}
        selectable={false}
        onClick={(info) => {
          if (info?.domEvent) {
            info.domEvent.preventDefault();
            info.domEvent.stopPropagation();
          }
          setFilterOpen(true);
        }}
      />
    </div>
  );

  return (
    <div className="ol-ribbon">
      <div className="ol-ribbonLeft">
        <Space size={12} align="center">
          <Button type="primary" className="ol-createBtn" onClick={onCreateEvent}>
            <i className="fa-regular fa-calendar-days" style={{ marginRight: 5 }}></i>
            Nuevo evento
          </Button>

          <Segmented
            value={view}
            onChange={setView}
            className="ol-viewTabs marginl-3"
            options={[
              { label: "Día", value: "day" },
              { label: "Semana laboral", value: "week_work" },
         
              { label: "Mes", value: "month" },
            ]}
          />
        </Space>

        <Space size={10} className="marginl-3">
          <Dropdown
            open={filterOpen}
            onOpenChange={(o) => setFilterOpen(o)}
            trigger={["click"]}
            placement="bottomLeft"
            dropdownRender={() => menuNode}
          >
            <Button icon={<FilterOutlined />}>
              Filtrar <i className="fa-solid fa-angle-down" style={{ marginLeft: 6 }}></i>
            </Button>
          </Dropdown>

          <Select
            mode="multiple"
            allowClear
            showSearch
            placeholder="Filtrar por autoridad"
            style={{ minWidth: 220, maxWidth: 320 }}
            maxTagCount="responsive"
            optionFilterProp="label"
            options={autoridadOptions || []}
            value={filters?.autoridadIds || []}
            onChange={(vals) => setFilters((p) => ({ ...(p || {}), autoridadIds: vals }))}
          />

          <Button onClick={() => onOpenPrint?.()}>
            <i className="fa-solid fa-print" style={{ marginRight: 5 }}></i>
            Imprimir
          </Button>

          <Button onClick={() => onOpenSearch?.()}>
            <i className="fa-solid fa-magnifying-glass" style={{ marginRight: 5 }}></i>
            Buscar agenda
          </Button>


        </Space>
      </div>
    </div>
  );
}
